import { ProductMenu } from './product-menu';
import { Type } from '@angular/core';
import { SpotlightHeaderComponent } from '../../modules/display/components/menus/spotlight-menu/building-blocks/menu-header/spotlight-header/spotlight-header.component';
import { SpotlightFooterComponent } from '../../modules/display/components/menus/spotlight-menu/building-blocks/menu-footer/spotlight-footer/spotlight-footer.component';
import { SectionType } from '../enum/dto/section-type.enum';
import { Section } from './section/section';
import { SectionRowViewModel } from '../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import type { FontStyleSheet } from './font-style-sheets';
import { SectionColumnViewModel } from '../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnType } from '../enum/shared/section-column-type';
import { SectionColumnProductInfoType } from '../enum/shared/section-column-product-info-type';

export class SpotlightMenu extends ProductMenu {
  public subTitle: string;

  protected override deserializeSections() {
    this.sections?.forEach(s => (s.sectionType = SectionType.Spotlight));
    this.sections = window?.injector?.Deserialize?.arrayOf(Section, this.sections) ?? [];
  }

  protected override deserializeTemplateSections() {
    this.templateSections?.forEach(templateSection => (templateSection.sectionType = SectionType.Spotlight));
    this.templateSections = window?.injector?.Deserialize?.arrayOf(Section, this.templateSections) ?? [];
  }

  getSectionWidthPercentage(): number {
    return 100;
  }

  getMenuClass(): string {
    return 'spotlight-menu';
  }

  getHeaderType(): Type<SpotlightHeaderComponent> {
    return SpotlightHeaderComponent;
  }

  getFooterType(): Type<SpotlightFooterComponent> {
    return SpotlightFooterComponent;
  }

  getShouldInflateColumnForRow(s: Section, col: SectionColumnViewModel, row: SectionRowViewModel): boolean {
    return true;
  }

  isInOverflowModeThatNeedsFlexWrap(): boolean {
    return super.isInOverflowModeThatNeedsFlexWrap() || this.hideOverflow();
  }

  getShouldSectionsContainerFlexWrap(): boolean {
    return this.isLandscape() || this.isInOverflowModeThatNeedsFlexWrap();
  }

  getColumnGroupingSpacerWidthPercentage(): number {
    return 0;
  }

  getShowFooter(): boolean {
    return false;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return null;
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.ProductTitle, 0],
      [SectionColumnProductInfoType.Brand, 1],
      [SectionColumnProductInfoType.Badge, 2],
      [SectionColumnProductInfoType.Strain, 3],
      [SectionColumnProductInfoType.StrainType, 4],
      [SectionColumnProductInfoType.QuantityAndSize, 5],
      [SectionColumnProductInfoType.Quantity, 6],
      [SectionColumnProductInfoType.Size, 7],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(8),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(9),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(10),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(11),
      [SectionColumnProductInfoType.GradingResults, 12],
      [SectionColumnProductInfoType.VariantPrice, 13],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 14]
    ]);
  }
}
